import { render, staticRenderFns } from "./NormalSearchNav460.vue?vue&type=template&id=3c4e3a22&scoped=true"
import script from "./NormalSearchNav460.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav460.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4e3a22",
  null
  
)

export default component.exports